import React, { useState } from 'react';
import { Star } from 'lucide-react';

const Reviews = () => {
    // State for each category
    const [chauffeurRating, setChauffeurRating] = useState(0);
    const [vehiculeRating, setVehiculeRating] = useState(0);
    const [horairesRating, setHorairesRating] = useState(0);

    return (
        <div className="section container">
            <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
                    <h1 style={{ marginBottom: '1rem' }}>Votre Avis Compte</h1>
                    <p style={{ color: 'var(--text-light)', fontSize: '1.1rem' }}>
                        Aidez-nous à améliorer nos services en évaluant nos prestations.
                    </p>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                    <form
                        action="https://formspree.io/f/mpqjqkrl"
                        method="POST"
                        style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
                    >
                        {/* 1. Comportement du chauffeur */}
                        <RatingCard
                            title="Comportement du chauffeur"
                            subtitle="Politesse, amabilité et professionnalisme."
                            name="rating_chauffeur"
                            rating={chauffeurRating}
                            setRating={setChauffeurRating}
                        />

                        {/* 2. Propreté du véhicule */}
                        <RatingCard
                            title="Propreté du véhicule *"
                            subtitle="Propreté intérieure et extérieure, confort."
                            name="rating_vehicule"
                            rating={vehiculeRating}
                            setRating={setVehiculeRating}
                            required
                        />

                        {/* 3. Respect des horaires */}
                        <RatingCard
                            title="Respect des horaires *"
                            subtitle="Ponctualité à l'heure de départ et d'arrivée."
                            name="rating_horaires"
                            rating={horairesRating}
                            setRating={setHorairesRating}
                            required
                        />

                        {/* Commentaires */}
                        <div style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.03)' }}>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, fontSize: '1.1rem' }}>Commentaires supplémentaires</label>
                            <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: '1rem', fontStyle: 'italic' }}>Partagez ici vos impressions ou suggestions.</p>
                            <textarea
                                name="message"
                                rows="4"
                                style={{ ...inputStyle, resize: 'vertical', backgroundColor: '#f8fafc' }}
                                placeholder="Votre réponse"
                            ></textarea>
                        </div>

                        {/* Nom (Optional, kept hidden or specific field if needed, user didn't explicitly ask to remove but showed a screenshot without it. I'll add a hidden input for now or just remove it to match screenshot exactly? The user screenshot shows 'Votre réponse' at bottom. I will stick to the screenshot design which implies just comments.) */}

                        <button type="submit" className="btn btn-primary" style={{ padding: '1rem', fontSize: '1.1rem', marginTop: '1rem' }}>
                            Envoyer mon avis
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

// Helper Component for Rating Sections
const RatingCard = ({ title, subtitle, rating, setRating, name, required }) => {
    const [hover, setHover] = useState(0);

    return (
        <div style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.03)', textAlign: 'center' }}>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: '0.25rem', color: '#1e293b' }}>
                {title} {required && <span style={{ color: '#ef4444' }}>*</span>}
            </h3>
            <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: '1.5rem', fontStyle: 'italic' }}>
                {subtitle}
            </p>

            <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem' }}>
                {[...Array(5)].map((_, index) => {
                    const ratingValue = index + 1;
                    return (
                        <label key={index} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                            <span style={{ fontSize: '0.8rem', color: '#94a3b8', fontWeight: 500 }}>{ratingValue}</span>
                            <input
                                type="radio"
                                name={name}
                                value={ratingValue}
                                style={{ display: 'none' }}
                                onClick={() => setRating(ratingValue)}
                                required={required}
                            />
                            <Star
                                size={32}
                                color={ratingValue <= (hover || rating) ? "#fbbf24" : "#cbd5e1"} // Yellow or Slate-300
                                fill={ratingValue <= (hover || rating) ? "#fbbf24" : "none"}
                                onMouseEnter={() => setHover(ratingValue)}
                                onMouseLeave={() => setHover(0)}
                                style={{ transition: 'all 0.2s', strokeWidth: 1.5 }}
                            />
                        </label>
                    );
                })}
            </div>
        </div>
    );
};

const inputStyle = {
    width: '100%',
    padding: '0.875rem',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
    fontFamily: 'inherit',
    fontSize: '1rem',
    outline: 'none',
    boxSizing: 'border-box'
};

export default Reviews;
